// removed by extract-text-webpack-plugin
module.exports = {"CategoryItem":"CategoryItemMobile__CategoryItem__2cZ6g","CategoryLogo":"CategoryItemMobile__CategoryLogo__K2irh","CategoryImage":"CategoryItemMobile__CategoryImage__3RgPx","CategoryName":"CategoryItemMobile__CategoryName__3g0Oz","Gold":"CategoryItemMobile__Gold__1fVwt","CategoryItemLink":"CategoryItemMobile__CategoryItemLink__URtcf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CategoryItem/CategoryItemMobile.css
// module id = 236
// module chunks = 0